<template>
  <div class="list-box">
    <div class="list-box-item" v-for="item in dataList" :key="item.ID">
      <div class="list-img" @click="entoDetailPage(item.ProductId, item.FreeCardNum)">
        <img v-lazy="item.ShowPicUrl" alt="" :key="item.ProductId"/>
        <!-- 抢光啦 -->
        <div class="soldout-mask" v-if="!item.IsInSaleSort || item.StockCount <= 0">
          <p>Sorry</p>
          <p>抢光啦</p>
        </div>
      </div>
      <div class="list-cnt">
        <div class="list-cnt-title" @click="entoDetailPage(item.ProductId, item.FreeCardNum)">
          <div class="title">
            <div class="l-freecard-tag" v-if="item.FreeCardNum !== null">
              <span>免单卡</span>
              <span>{{item.FreeCardNum}}</span>
            </div>{{item.TitleShort || '----'}}
          </div>
        </div>
        <div class="list-cnt-btm">
          <div class="list-btm-price">
            <span>￥</span>{{item.IsFreeCard ? '0' : item.ProductPrice}}
          </div>
          <div class="flex">
            <button class="list-btm-btn" @click="deleteBlackProduct(item.ProductId)">恢复展现</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      require: true,
      default: () => {
        return []
      }
    }
  },
  methods: {
    entoDetailPage (productId, freeCardNum) {
      let isFreeCard = false
      if (freeCardNum !== null) isFreeCard = true
      this.$emit('entoDetailPage', productId, isFreeCard)
    },
    deleteBlackProduct (productId) {
      this.$emit('deleteBlackProduct', productId)
    }
  }
}
</script>

<style scoped>
  .list-box-item{
    position: relative;
    display: flex;
    align-items: center;
    height: 125px;
    width: 100%;
    box-sizing: border-box;
    padding: 8px 10px;
    background: #fff;
    margin-top: 10px;
  }
  .list-box-item:first-child{
    margin-top: 0;
  }
  .list-img{
    position: relative;
    width: 109px;
    height: 100%;
    flex-shrink: 0;
  }
  .list-img img{
    display: block;
    height: 100%;
    width: 100%;
    border-radius: 3px;
  }
  .list-cnt{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 10px;
    flex-grow: 1;
    height: 100%;
  }
  .list-cnt-title{
    height: 75%;
    overflow: hidden;
  }
  .list-cnt-title > .title{
    max-width: 85%;
    max-height: 45px;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .list-cnt-btm{
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
  }
  .list-btm-price{
    color: #f23030;
    font-size: 20px;
    line-height: 20px;
  }
  .list-btm-price > span{
    font-size: 12px;
    font-weight: 600;
  }
  .list-btm-btn{
    width: 80px;
    line-height: 22px;
    text-align: center;
    color: #f23030;
    background: #fff;
    border: 1px solid #f23030;
    padding: 2px 0;
    margin-left: 5px;
    border-radius: 15px;
  }
  .list-btm-btn:active{
    opacity: 0.8;
  }
  .list-btm-btn.cancel{
    color: #333;
    border-color: #333;
  }
  @media screen and (max-width: 320px){
    .list-btm-btn{
      width: 72px;
      line-height: 20px;
    }
  }
</style>
